module.exports = __webpack_public_path__ + "static/img/tu3-m.ef0afb99.png";